<template lang="pug">
v-card.border-g-e8(flat)
    v-card-text.py-2
        .d-flex.align-center.flex-wrap.mb-1
            .text-h6.font-weight-bold {{$t('labels.order_details')}}
            edit-order-modal.ml-auto(v-if="!forCompany" :model="model")

        meal-row(
            v-for="(meal, index) in model.meals"
            :meal="meal"
            :currency="model.currency"
            :locale="model.currencyLocale"
            :key="`meal-${index}`")
        v-divider.my-2
        .d-flex.justify-space-between.text-body-1.g-26--text
            span {{$t('orders.subtotal')}}
            span {{ model.priceSumItems| currency(model.currency,model.currencyLocale) }}
        .d-flex.justify-space-between.text-body-1.g-26--text
            span {{$t('labels.delivery_fee')}}
            span {{ model.priceDelivery | currency(model.currency, model.currencyLocale) }}
        .d-flex.justify-space-between.text-body-1.g-26--text(v-if="model.companyServiceFee && model.companyServiceFee != 0")
            span {{$t('labels.service_fee')}}
            span {{ model.companyServiceFee | currency(model.currency, model.currencyLocale) }}
        .d-flex.justify-space-between.text-body-1.g-26--text(v-if="model.firmDiscount")
            span {{$t('labels.discount')}} (company)
            span -{{ model.firmDiscount | currency(model.currency, model.currencyLocale) }}
        .d-flex.justify-space-between.text-body-1.g-26--text(v-if="model.userDiscount")
            span {{$t('labels.discount')}} (user)
            span -{{ model.userDiscount | currency(model.currency, model.currencyLocale) }}
        .d-flex.justify-space-between.text-body-1.g-26--text(v-if="model.priceCouponDiscount")
            span {{$t('labels.coupon_discount')}}
            span -{{ model.priceCouponDiscount | currency(model.currency, model.currencyLocale) }}
        .d-flex.justify-space-between.text-body-1.g-26--text.font-weight-medium(v-if="!forCompany || !hasServiceFee")
            span {{$t('labels.total')}}
            span {{ model.priceSum | currency(model.currency, model.currencyLocale) }}
        div(v-else)
            .d-flex.justify-space-between.text-body-1.g-26--text
                span {{$t('labels.order_total')}}
                span {{ model.priceSum | currency(model.currency, model.currencyLocale) }}
            v-divider.my-1
            .d-flex.justify-space-between.text-body-1.g-26--text
                span {{$t('labels.service_fee')}}
                span {{ getServiceFee(model) | currency(model.currency, model.currencyLocale) }}
            .d-flex.justify-space-between.text-body-1.g-26--text.font-weight-medium
                span {{$t('labels.invoice_total')}}
                span {{ orderPriceTotal(model) | currency(model.currency, model.currencyLocale) }}
        v-divider.my-2
        .text-body-1.g-26--text.font-weight-medium.mb-2 {{$t('labels.payment')}}
        .d-flex.justify-space-between.text-body-1.g-26--text.mb-2(v-if="model.priceSumFirm > 0")
            span(v-if="model && model.id")
                template(v-if="orderIsCanteenAndHasBudget")
                    span {{ model.cloudcanteen.name }}
                    v-icon(small @click="copyCanteenUrl").ml-2 content_copy
                template(v-else-if="model.selectedExpenseRuleId")
                    span(v-if="selectedExpenseRule.id") {{ selectedExpenseRule.name }}
                    v-icon(small @click="copyAllowanceUrl").ml-2 content_copy
                span(v-else) {{ $t('texts.deleted_allowance') }}
            span {{ model.priceSumFirm | currency(model.currency, model.currencyLocale) }}
        .mb-2(v-if="model.priceSumUser > 0")
            div(v-if="model.paymentMethod")
                template(v-if="model.stripePayments && model.stripePayments.length")
                    payment-row(v-for="(stripePayment, stripeIdx) in model.stripePayments" :key="`stripe-${stripeIdx}`" :currency="model.currency" :currency-locale="model.currencyLocale" :done="stripePayment.isUpdated" :price="stripePayment.chargeDataAmount" :copy-text="`https://dashboard.stripe.com/payments/${stripePayment.paymentIntentId}`" :status="stripePayment.chargeDataStatus" :card-last4="stripePayment.paymentMethodCardLast4" :card-brand="stripePayment.paymentMethodCardBrand" :payment="stripePayment.paymentMethodDetailsCardWallet")
                template(v-else)
                    .d-flex.justify-space-between.text-body-1.g-26--text
                        span {{ $t('orders.paid_by_method', {method: $t(`enums.payment_methods.${model.paymentMethod}`)}) }}
                        span {{ model.priceSumUser | currency(model.currency, model.currencyLocale) }}
            template(v-else-if="canteen")
                .d-flex.justify-space-between.text-body-1.g-26--text(
                    v-for="(payment, index) in canteen.paymentSummary"
                    v-if="payment.paymentMethod"
                    :key="`canteenPayment-${index}`")
                    span(v-if="payment.paymentMethod") {{ $t('orders.paid_by_method', {method: $t(`enums.payment_methods.${payment.paymentMethod}`)}) }}
                    span(v-if="payment.paymentMethod") {{ payment.priceSumUser | currency(model.currency, model.currencyLocale) }}
        div(v-if="model.refunds && model.refunds.length")
            v-divider.my-2
            .text-body-1.g-26--text.font-weight-medium.mb-2 {{$t('labels.order_refund')}}
            div(v-for="refund in model.refunds")
                template(v-if="refund.userAmount && getStripeRefund()")
                    payment-row(:currency="model.currency" :currency-locale="model.currencyLocale" :price="refund.userAmount * -1" :copy-text="`https://dashboard.stripe.com/payments/${getStripeRefund().refundId}`" :status="getStripeRefund().status" :card-last4="model.stripePayments[0].paymentMethodCardLast4" :card-brand="model.stripePayments[0].paymentMethodCardBrand" :payment="model.stripePayments[0].paymentMethodDetailsCardWallet" :done="true")
                    .text-body-2.py-2.mb-2 {{ refund.createdAt | toDate('D MMM YYYY, HH:mm') }}
                template(v-if="refund.companyAmount")
                    .d-flex.justify-space-between.text-body-1.g-26--text()
                        template(v-if="orderIsCanteen")
                            span {{ model.cloudcanteen.name }}
                            v-icon(small @click="copyCanteenUrl").ml-2 content_copy
                        template(v-else-if="model.selectedExpenseRuleId")
                            span(v-if="selectedExpenseRule.id") {{ selectedExpenseRule.name }}
                            v-icon(small @click="copyAllowanceUrl").ml-2 content_copy
                        span(v-else) {{ $t('texts.deleted_allowance') }}
                        span {{ (refund.companyAmount * -1) | currency(model.currency, model.currencyLocale) }}
                    .text-body-2.py-2.mb-2 {{ refund.createdAt | toDate('D MMM YYYY, HH:mm') }}

        div(v-if="!forCompany")
            .text-body-1.g-26--text.mt-4
                .d-flex.align-center.flex-wrap.mb-1
                    .d-flex
                        v-icon.mr-1(color="g-26" dense) receipt
                        | {{$t('labels.expense_code')}}:
                    v-btn.px-0.ml-auto(
                        color="primary"
                        @click="onCostCodeClick" text x-small)
                        span.text-subtitle-2 {{$t('labels.change')}}
                        v-icon(dense) chevron_right
                multi-cost-code-display(:item="model" :show-arrow="false" :truncate-codes="false")
                multi-cost-code-edit-modal(:item="editCostCode" @close="editCostCode = null" @update:item="onCostCodeSave")
            v-divider.my-2
            h3 {{$t('labels.order_status')}}:
            .d-flex.align-center
                small {{$t('labels.last_modified')}}: {{ this.orderLastModified.user }} at {{ this.orderLastModified.createdAt }}
            .d-flex.align-center(v-if="!isMultiCutoff")
                v-tooltip(v-if="cancelReason" bottom)
                    template(v-slot:activator="{ on }")
                        h3.text-truncate(v-on="on") {{$t(`enums.order_status.${status}`)}} - {{cancelReason}}
                    span {{cancelReason}}
                h3(v-else) {{$t(`enums.order_status.${status}`)}}
                .d-flex.ml-auto
                    edit-button(v-if="status.startsWith('cancelled') && isDeliverect" :tooltip="$t('actions.order.cancel_deliverect')" icon='cancel_schedule_send' @execute="deliverectCancel")
                    edit-button(v-if="model.status !== 'approved'" :tooltip="$t('labels.approve_order')" icon='check_circle' @execute="confirmOrderModal")
                    edit-button.ml-2(v-if="model.status !== 'cancelled' && model.status !== 'cancelled-after-approval'" :tooltip="$t('labels.cancel_order')" icon='cancel' @execute="orderCancelConfirm = true")
                    reorder-modal.ml-2( :order="model" :tooltip="$t('labels.reorder')" target icon)
                        v-icon replay_circle_filled
            div(v-else)
                div(v-for="(detail, index) in multicutoffDetails" :key="detail.nr")
                    .d-flex.align-center
                        h4 {{ $t('orders.multi_cutoff') }} {{ detail.nr }}. ({{ detail.cutoff }})
                            v-chip.ml-2(label x-small :color="detail.confirmed ? 'success' : 'info'") {{ $t(detail.confirmed ? 'orders.confirmed' : 'enums.order_status.new') }}
                        .d-flex.ml-auto
                            edit-button(v-if="(index === 0 && model.status !== 'approved') || !detail.confirmed" :tooltip="$t('labels.approve_order')" icon='check_circle' small @execute="confirmOrderModal(detail.cutoffTime)")
                            edit-button.ml-2(v-if="index === 0 && model.status !== 'cancelled' && model.status !== 'cancelled-after-approval'" :tooltip="$t('labels.cancel_order')" icon='cancel' small @execute="orderCancelConfirm = true")
                    small {{ $t('orders.suborders') }}: {{ detail.count }}/{{ detail.limit }}

            strong-confirm-modal(
                v-model="strongConfirm"
                :title="strong.title"
                :text="strong.text"
                :approve-color="strong.approveColor"
                @onApprove="strongAction"
                @onCancel="strongConfirm = false")
            order-cancel-modal(
                v-model="orderCancelConfirm"
                :order-id="model.id"
                :has-firm-payment="model.priceSumFirm !== '0.00'"
                @order-cancelled="onCancelOrder")

        slot
</template>

<script>
import { mapGetters } from 'vuex'
import baseFormType from '@/store/type/baseFormType'
import canteenType from '@/store/type/canteenType'
import RestApiCollection from '@/api/RestApiCollection'
import RestApiType from '@/api/RestApiType'
import MapperType from '@/services/mapper/MapperType'
import CompanyServiceFeeMixin from '@/components/mixins/CompanyServiceFee'
import MealRow from '@/components/pages/orders/tabs/general/MealRow.vue'
import EditOrderModal from '@/components/pages/orders/tabs/general/dialog/EditOrderModal.vue'
import EditButton from '@/components/table/buttons/EditButton.vue'
import ReorderModal from '@/components/pages/orders/tabs/general/dialog/ReorderModal.vue'
import StrongConfirmModal from '@/components/confirm/StrongConfirmModal.vue'
import OrderCancelModal from '../../OrderCancelModal.vue'
import MultiCostCodeDisplay from '../../parts/MultiCostCodeDisplay.vue'
import MultiCostCodeEditModal from '../../tableParts/MultiCostCodeEditModal.vue'
import { getId } from '@/services/IdFromIri'
import {
    multicutoffDetails,
    isMultiCutoffBaseOrder,
} from '@/services/Orders/CanteenMultiCutoffRuleLogic'
import Notification from '@/services/Notification/Notification'
import PaymentRow from '@/components/pages/orders/tabs/general/components/PaymentRow.vue'

const modalBase = {
    title: '',
    text: '',
    action: '',
    approveColor: null,
}

export default {
    components: {
        PaymentRow,
        EditOrderModal,
        MealRow,
        EditButton,
        ReorderModal,
        StrongConfirmModal,
        OrderCancelModal,
        MultiCostCodeDisplay,
        MultiCostCodeEditModal,
    },
    mixins: [CompanyServiceFeeMixin],
    props: {
        model: Object,
        forCompany: Boolean,
    },
    data() {
        return {
            orderLastModified: {},
            strongConfirm: false,
            strong: { ...modalBase },
            orderCancelConfirm: false,
            confirmCutoff: null,
            editCostCode: null,
            selectedExpenseRule: {},
        }
    },
    computed: {
        ...mapGetters({
            canteen: canteenType.getters.CANTEEN,
        }),
        orderIsCanteenAndHasBudget() {
            return (
                this.orderIsCanteen &&
                this.model.cloudcanteen.budgetLimit !== null
            )
        },
        status() {
            return this.model?.status || 'init-payment'
        },
        orderIsCanteen() {
            return this.model.cloudcanteen || this.model.residentialcanteen
        },
        cancelReason() {
            let str = null
            const reasonType = this.model?.adminCancelReasonType
            if (reasonType) {
                str = this.$t(`enums.order_cancel_reasons.${reasonType}`)
                if (this.model?.adminCancelReason?.length) {
                    str += ': ' + this.model.adminCancelReason
                }
            }
            return str
        },
        cappedCancelReason() {
            let reason = this.cancelReason
            if (reason) {
                reason = ' - ' + reason.substring(0, 18)
            }
            return reason
        },
        isMultiCutoff() {
            return isMultiCutoffBaseOrder(this.model)
        },
        multicutoffDetails() {
            return multicutoffDetails(this.model)
        },
        isDeliverect() {
            return !!this.model?.softwareSendings
                ?.filter((el) => el.software === 'deliverect')
                .pop()
        },
    },
    watch: {
        'model.id': {
            handler() {
                if (!this.forCompany) {
                    this.getLastModifyInfo()
                }
                this.getCanteen()
                this.getSelectedExpenseRule()
            },
        },
    },
    methods: {
        getStripeRefund() {
            for (let stripePayment of this.model.stripePayments) {
                if (
                    stripePayment.stripeRefunds &&
                    stripePayment.stripeRefunds.length
                ) {
                    return stripePayment.stripeRefunds[0]
                }
            }
        },
        copyAllowanceUrl() {
            const host = window.location.origin
            const companyId = this.model.company.split('/').pop()
            this.copy(
                `${host}/companies/${companyId}/allowances/${this.model.selectedExpenseRuleId}`
            )
        },
        copyCanteenUrl() {
            const host = window.location.origin
            const companyId = this.model.company.split('/').pop()
            this.copy(
                `${host}/companies/${companyId}/cloudcanteens/${this.model.cloudcanteen.id}`
            )
        },
        copy(text) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text)
            }
        },
        stripeStatusColor(status) {
            return (
                {
                    succeeded: 'success',
                }[status] || 'orange'
            )
        },
        strongAction() {
            this[this.strong.action]().then(() => {
                this.strongConfirm = false
            })
        },

        confirmOrderModal(cutoff) {
            // complicated a bit to send cutoff confirmation to every canteen order
            this.confirmCutoff =
                cutoff ||
                (this.orderIsCanteen
                    ? this.$date(
                          this.model.cloudcanteen?.cutoffTime ||
                              this.model.residentialcanteen?.cutoffTime
                      ).format('YYYY-MM-DD HH:mm:ss')
                    : null)
            this.strong = {
                ...modalBase,
                title: this.$t('labels.approve_order'),
                text: this.$t(
                    'orders.do_you_really_want_to_approve_this_order',
                    { orderIdentifier: this.model.identifier }
                ),
                action: 'confirmOrder',
            }
            this.strongConfirm = true
        },

        async confirmOrder() {
            if (this.model?.status !== 'approved') {
                await RestApiCollection.get(RestApiType.ORDERS).approve(
                    this.model.id
                )
            }

            if (this.confirmCutoff) {
                await RestApiCollection.get(
                    RestApiType.RESTAURANTS
                ).sendCanteenNotiConfirm(
                    getId(this.model.restaurant),
                    this.model?.cloudcanteen?.identifier ||
                        this.model?.residentialcanteen?.identifier,
                    this.confirmCutoff
                )
                this.confirmCutoff = null
            }

            this.$store.dispatch(`baseForm/${baseFormType.actions.LOAD}`, {
                api: RestApiType.ORDERS,
                id: this.model.id,
                mapper: MapperType.ORDER_FORM,
            })
        },

        onCancelOrder() {
            this.$store.dispatch(`baseForm/${baseFormType.actions.LOAD}`, {
                api: RestApiType.ORDERS,
                id: this.model.id,
                mapper: MapperType.ORDER_FORM,
            })
        },

        getCanteen() {
            if (this.model?.cloudcanteen || this.model?.residentialcanteen) {
                RestApiCollection.get(
                    RestApiType.RESTAURANT_ORDER_CANTEENS
                ).get(
                    getId(this.model.restaurant),
                    this.model?.cloudcanteen?.identifier ||
                        this.model?.residentialcanteen?.identifier
                )
            }
        },

        async getSelectedExpenseRule() {
            if (!this.model?.selectedExpenseRuleId) {
                return
            }

            this.selectedExpenseRule = await RestApiCollection.get(
                RestApiType.COMPANY_ALLOWANCES
            ).get(this.model.selectedExpenseRuleId)
        },

        getLastModifyInfo() {
            const exportParams = {
                limit: 1,
                property: 'status',
            }
            RestApiCollection.get(RestApiType.AUDITLOG)
                .get(this.model.id, 'Ordering', exportParams)
                .then((response) => {
                    const lastModifiedRow = response.slice(0, 1)
                    this.$set(this, 'orderLastModified', {
                        user: lastModifiedRow[0]?.blame_user || 'system',
                        createdAt: this.$date
                            .utc(lastModifiedRow[0].created_at)
                            .local()
                            .format('YYYY-MM-DD HH:mm:ss'),
                    })
                })
        },

        deliverectCancel() {
            RestApiCollection.get(RestApiType.ORDERS)
                .queueDeliverectCancel(this.model.id)
                .then(() => {
                    Notification.success(
                        this.$t('notifications.deliverect_cancel_sent'),
                        this.$t('notifications.success')
                    )
                })
        },

        onCostCodeClick() {
            this.editCostCode = this.model
        },
        onCostCodeSave(newModel) {
            this.$store.dispatch(`baseForm/${baseFormType.actions.LOAD}`, {
                api: RestApiType.ORDERS,
                id: newModel.id,
                mapper: MapperType.ORDER_FORM,
            })
        },
    },
}
</script>
